import React from "react";
import { Modal } from "../ui/Modal";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  memberPasswordRequestToggle,
  saveMemberPasswordRequest,
  setMemberPasswordValue,
} from "../../actions/patientRegisterActions";

const MemberPasswordRequestModal = ({ show, title, onClose, ...props }) => {
  const dispatch = useDispatch();
  const {
    patientRegister: { memberPassword },
  } = useSelector((store) => store);

  return (
    <Modal
      {...props}
      show={show}
      title={title}
      onHide={onClose}
      keyboard={false}
      actions={
        <>
          <Button onClick={() => dispatch(memberPasswordRequestToggle(false))}>Cancel</Button>
          <Button
            className="btn-primary"
            disabled={memberPassword.length === 0}
            onClick={() => dispatch(saveMemberPasswordRequest())}
          >
            Ok
          </Button>
        </>
      }
    >
      <input
        type="password"
        placeholder="password"
        className="form-control"
        value={memberPassword}
        onKeyDown={(e) => {
          if (e.keyCode === 13) {
            dispatch(saveMemberPasswordRequest());
          }
        }}
        onChange={(e) => dispatch(setMemberPasswordValue(e.target.value))}
      />
    </Modal>
  );
};
export default MemberPasswordRequestModal;
